export default "__VITE_PUBLIC_ASSET__0b8e4b1c__"